import { render, staticRenderFns } from "./TourMailList.vue?vue&type=template&id=5f1d7deb&scoped=true"
import script from "./TourMailList.vue?vue&type=script&lang=js"
export * from "./TourMailList.vue?vue&type=script&lang=js"
import style0 from "./TourMailList.vue?vue&type=style&index=0&id=5f1d7deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d7deb",
  null
  
)

export default component.exports